import { useState, useEffect } from 'react';

interface UseTimerReturn {
  timeLeft: number;
  isExpired: boolean;
  formatTime: () => string;
}

export const useWalletAddressTimer = (initialTime: number = 600): UseTimerReturn => {
  const [timeLeft, setTimeLeft] = useState(initialTime);
  const isExpired = timeLeft <= 0;

  useEffect(() => {
    if (isExpired) return;

    const interval = setInterval(() => {
      setTimeLeft(prev => prev - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [isExpired]);

  const formatTime = (): string => {
    const minutes = Math.floor(timeLeft / 60);
    const seconds = timeLeft % 60;
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  return { timeLeft, isExpired, formatTime };
};
